// extracted by mini-css-extract-plugin
export var askAiIcon = "_np-j";
export var category = "_np-9";
export var categoryHeader = "_np-e";
export var container = "_np-0";
export var group = "_np-a";
export var groupItems = "_np-f";
export var groupSeparator = "_np-k";
export var loading = "_np-1";
export var noResults = "_np-3";
export var placeholder = "_np-2";
export var resultContent = "_np-5";
export var resultIcon = "_np-c";
export var resultItem = "_np-g";
export var resultMeta = "_np-8";
export var resultSubtitle = "_np-7";
export var resultSuffix = "_np-i";
export var resultTitle = "_np-6";
export var resultsList = "_np-4";
export var searchGroup = "_np-d";
export var selected = "_np-h";
export var subgroup = "_np-b";